function App() {
    return (
        <div className="d-flex justify-content-center">
            <h1 className='notification'><br/><br/>Sorry. The page you are looking for is not found</h1>
        </div>
    );
  }
  
  export default App;